import React from "react";
import { Alert } from "react-bootstrap";

const Message = ({ variant = "danger", children }) => {
  // Base style: white card, rounded, subtle shadow, consistent padding
  const baseStyle = {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    padding: "10px 14px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.04)",
    borderWidth: "1px",
    borderStyle: "solid",
    fontSize: "14px",
  };

  // Colors per variant (text + border)
  let styleByVariant = {};

  switch (variant) {
    case "success":
      styleByVariant = {
        borderColor: "#16A34A",    // green border
        color: "#16A34A",          // green text
        backgroundColor: "#ECFDF3" // light green bg
      };
      break;
    case "info":
      styleByVariant = {
        borderColor: "#B45309",    // brown border
        color: "#B45309",          // brown text
        backgroundColor: "#FFFBEB" // light brown/yellow bg
      };
      break;
    case "danger":
    default:
      styleByVariant = {
        borderColor: "#DC2626",    // red border
        color: "#B91C1C",          // deep red text
        backgroundColor: "#FEF2F2" // light red bg
      };
      break;
  }

  const finalStyle = { ...baseStyle, ...styleByVariant };

  return (
    <>
    {/* force variant="light" so Bootstrap colors do not fight ours */}
    <Alert variant="light" style={finalStyle} className="m-0">
      {children}
    </Alert>
  </>
  );
};

export default Message;
